/**
 * Bloqueio das requisições do DiscountYard (URLs com "_discountyard") enquanto
 * um cupom nativo está sendo aplicado — compartilhado pelo /cart
 * (assets/cart-discount-orchestrator.js, assets/cart-discount.js) e pelo
 * carrinho da adição facilitada (assets/zrzs-quick-add-discount.js).
 *
 * Os originais de fetch/XHR ficam em window de propósito: o patch é global e
 * qualquer um que desbloqueie precisa restaurar os mesmos originais.
 */

/** @typedef {{ _originalFetch?: typeof fetch, _originalXHROpen?: typeof XMLHttpRequest.prototype.open, _originalXHRSend?: typeof XMLHttpRequest.prototype.send, _discountyardBlocked?: boolean }} DiscountYardBlockWindow */

export function blockDiscountyardRequests() {
  const BLOCK_PATTERN = '_discountyard';

  /** @type {Window & DiscountYardBlockWindow} */
  const win = window;

  // Guarda originais apenas uma vez
  if (!win._originalFetch) {
    win._originalFetch = window.fetch;
  }
  if (!win._originalXHROpen) {
    win._originalXHROpen = window.XMLHttpRequest.prototype.open;
  }
  if (!win._originalXHRSend) {
    win._originalXHRSend = window.XMLHttpRequest.prototype.send;
  }

  win._discountyardBlocked = true;

  /* --- Intercept fetch --- */
  const originalFetch = win._originalFetch;
  window.fetch = function (...args) {
    const url = String(args[0] ?? '');
    if (url.includes(BLOCK_PATTERN)) {
      return Promise.reject(new Error('Blocked by script'));
    }
    return originalFetch.apply(this, args);
  };

  /* --- Intercept XHR --- */
  const OriginalXHR = window.XMLHttpRequest;
  const open = win._originalXHROpen;

  /**
   * @param {string} _method
   * @param {string | URL} url
   */
  OriginalXHR.prototype.open = function (_method, url) {
    // @ts-ignore
    this._blocked = false;

    if (String(url).includes(BLOCK_PATTERN)) {
      // eslint-disable-next-line no-console
      console.warn('[BLOCKED XHR]', url);
      // @ts-ignore
      this._blocked = true;
    }

    return open.apply(this, arguments);
  };

  const send = win._originalXHRSend;
  OriginalXHR.prototype.send = function () {
    // @ts-ignore
    if (this._blocked) {
      // aborta a requisição silenciosamente
      return;
    }
    return send.apply(this, arguments);
  };

  // eslint-disable-next-line no-console
  console.info('✅ Network blocking enabled for pattern:', BLOCK_PATTERN);
}

export function unblockDiscountyardRequests() {
  /** @type {Window & DiscountYardBlockWindow} */
  const win = window;
  if (!win._discountyardBlocked) return;
  if (win._originalFetch) {
    window.fetch = win._originalFetch;
    delete win._originalFetch;
  }
  if (win._originalXHROpen) {
    window.XMLHttpRequest.prototype.open = win._originalXHROpen;
    delete win._originalXHROpen;
  }
  if (win._originalXHRSend) {
    window.XMLHttpRequest.prototype.send = win._originalXHRSend;
    delete win._originalXHRSend;
  }
  win._discountyardBlocked = false;
}
